import anime from 'animejs/lib/anime';
import inView from 'in-view';
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
    // Animations for the landing page
    inView('.header-landing').once('enter', () => {
        anime({
            targets: ['.header-landing-logo img'],
            translateY: ['50%', '0%'],
            opacity: ['0', '100%'],
            duration: 1800,
            easing: 'spring(1, 50, 50, 0)',
        });
    });

    inView('.header-landing').once('enter', () => {
        anime({
            targets: ['.header-landing-title'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 500 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.header-landing-intro'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 750 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.highlight'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 1000 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
    }, {
        threshold: 1,
    });

    inView('.block-landings-infos').once('enter', () => {
        anime({
            targets: ['.block-infos-text-wrapper p'],
            translateY: ['10%', '0%'],
            opacity: ['0', '100%'],
            duration: 1500,
            delay: anime.stagger(200, { start: 500 }),
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.block-infos-text-wrapper a'],
            translateY: ['10%', '0%'],
            opacity: ['0', '100%'],
            duration: 1500,
            delay: anime.stagger(200, { start: 500 }),
            easing: 'spring(1, 50, 10, 0)',
        });
    }, {
        threshold: 1,
    });

    inView('.block-expertise-details').once('enter', () => {
        anime({
            targets: ['.block-expertise-details *'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 250 }),
            duration: 1000,
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.block-expertise-item'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(100, { start: 500 }),
            duration: 1000,
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.block-expertise-item .bullet'],
            scale: ['0', '100%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(100, { start: 500 }),
            duration: 1000,
            easing: 'spring(1, 50, 10, 0)',
        });
    }, {
        threshold: 1,
    });

    inView('.block-achievements .description').once('enter', () => {
        anime({
            targets: ['.block-achievements .description'],
            translateY: ['10%', '0%'],
            opacity: ['0', '100%'],
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
    }, {
        threshold: 0.5,
    });

    // Animations for the block CTA
    inView('.landing-block-cta').once('enter', () => {
        anime({
            targets: ['.block-cta-wrapper'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 500 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
    });

    // Animations for certification
    inView('.block-certification').once('enter', () => {
        anime({
            targets: ['.block-certification-title h2, .block-certification-title div'],
            translateX: ['-50%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 800 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
        anime({
            targets: ['.block-certification-infos'],
            translateY: ['30%', '0%'],
            opacity: ['0', '100%'],
            delay: anime.stagger(200, { start: 1000 }),
            duration: 1500,
            easing: 'spring(1, 50, 10, 0)',
        });
    });

    // Contact button handling while scrolling the page
    inView('.block-landing-highlights')
        .on('enter', () => {
            $('.floating-button').addClass('visible');
        });
    inView('.block-contact')
        .on('enter', () => {
            $('.floating-button').removeClass('visible');
        })
        .on('exit', () => {
            $('.floating-button').addClass('visible');
        });
    inView('.footer')
        .on('exit', () => {
            $('.floating-button').removeClass('visible');
        });
});
